import api from '../utils/api';

// Fetch all terms
export const getTerms = async (headers) => {
  try {
    const response = await api.get('/api/terms', headers);
    return response.data;
  } catch (error) {
    console.error('Error fetching terms:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific term by ID
export const getTermById = async (id, headers) => {
  try {
    const response = await api.get(`/api/terms/${id}`, headers);
    console.log("get one term ", response.data)
    return response.data;
  } catch (error) {
    console.error(`Error fetching term with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new term
export const createTerm = async (termData, headers) => {
  try {
    const response = await api.post('/api/terms', termData, headers);
    return response.data;
  } catch (error) {
    console.error('Error creating term:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing term
export const updateTerm = async (id, termData, headers) => {
  try {
    const response = await api.put(`/api/terms/${id}`, termData, headers);
    return response.data;
  } catch (error) {
    console.error(`Error updating term with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a term
export const deleteTerm = async (id, headers) => {
  try {
    const response = await api.delete(`/api/terms/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error(`Error deleting term with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};
